﻿export * from './loancontract.component';
